module.exports = __webpack_public_path__ + "img/overview-bg.97b5b980.png";